import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";

const Sidebar = ({ menuItems }) => {
  const location = useLocation();

  return (
    <div className="sidebar">
      <ul>
        {menuItems.map((item) => {
          const isActive = location.pathname.includes(item.path);
          return (
            <li key={item.path} className={isActive ? "active" : ""}>
              <Link to={item.path}>{item.name}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
